"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reward = void 0;
const constants_1 = require("../../utils/constants");
class Reward {
    createXp(xp) {
        return {
            type: constants_1.QuestRewardTypeConst.REWARD_XP,
            xp,
        };
    }
    createSkillScores({ skillScores }) {
        return {
            type: constants_1.QuestRewardTypeConst.REWARD_SKILL_SCORE,
            skills: skillScores,
        };
    }
    createBadge({ title, description, imageIPFS }) {
        return {
            type: constants_1.QuestRewardTypeConst.REWARD_BADGE,
            title,
            imageIPFS,
            description,
        };
    }
    createCustomReward({ type, label, metadata, skills, xp }) {
        return {
            type,
            label,
            metadata,
            skills,
            xp,
        };
    }
}
exports.Reward = Reward;
